import { useState, useEffect } from "react";
import TelaLogin from "./components/TelaLogin";
import styled from "styled-components";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "./api.js";
import FormRodada from "./components/FormRodada.js";
import GridRodadas from "./components/GridRodadas.js";
import FormUsuarios from "./components/FormUsuarios.js";
import GridUsuarios from "./components/GridUsuarios.js";
import FormTimes from "./components/FormTimes.js";
import GridTimes from "./components/GridTimes.js";
import DadosRodada from "./components/DadosRodada.js";
import FormFinancas from "./components/FormFinancas.js";
import DescricaoFinanceiro from "./components/DescricaoFinanceiro.js";
import TelaPagamentos from "./components/TelaPagamentos.js";
import AdminPix from "./components/AdminPix.js";
import AdminSaldos from "./components/AdminSaldos.js";

// ID da liga — extraído para facilitar mudança futura
export const ID_LIGA = 3;

const AppWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 10px 40px 10px;
`;

const Header = styled.div`
  background-color: #1a5276;
  color: white;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  margin-left: -10px;
  margin-right: -10px;
`;

const Title = styled.h2`
  font-size: clamp(16px, 4vw, 22px);
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.5px;
`;

const Menu = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
`;

const MenuButton = styled.button`
  padding: 8px 14px;
  border: none;
  background-color: #2980b9;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1a6a9a;
  }

  &.active {
    background-color: #1abc9c;
  }
`;

const LogoutButton = styled.button`
  padding: 8px 14px;
  border: none;
  background-color: #c0392b;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: #96281b;
  }
`;

const LoginButton = styled.button`
  padding: 10px 24px;
  border: none;
  background-color: #2980b9;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  margin-top: 12px;
  align-self: center;

  &:hover {
    background-color: #1a6a9a;
  }
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

function App() {
  const [user, setUser] = useState(null);
  const [onEdit, setOnEdit] = useState(null);
  const [times, setTimes] = useState([]);
  const [users, setUsers] = useState([]);
  const [rodada, setRodada] = useState([]);
  const [rodadasLiga, setRodadasLiga] = useState(ID_LIGA);
  const [currentPage, setCurrentPage] = useState("dados");
  const [financeiro, setFinanceiro] = useState([]);

  const getTimes = async () => {
    try {
      const res = await api.get("liga/ListarTimes");
      setTimes(res.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getUsers = async () => {
    try {
      const res = await api.get("liga/listarUsuarios");
      setUsers(res.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getRodadas = async (idLiga) => {
    try {
      const res = await api.get(`liga/listarRodadas/${idLiga || rodadasLiga}`);
      setRodada(res.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  async function getFinanceiro(idUsuario) {
    try {
      const res = await api.get("liga/ListaFinanceiro/" + idUsuario);
      setFinanceiro(res.data);
    } catch (error) {
      toast.error(error.message);
    }
  }

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    if (user) {
      getUsers();
      getTimes();
      getRodadas();
    }
  }, [user]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    setCurrentPage("dados");
    toast.success("Logout realizado!");
  };

  async function MenuFinanceiro() {
    setCurrentPage("financeiro");
    getFinanceiro(user.id);
  }

  return (
    <AppWrapper>
      {!user ? (
        <>
          <Header>
            <Title>Cartola Resenha</Title>
          </Header>
          <Content>
            {currentPage !== "login" && <DadosRodada />}
            {currentPage !== "login" && (
              <LoginButton onClick={() => setCurrentPage("login")}>
                Entrar
              </LoginButton>
            )}
            {currentPage === "login" && <TelaLogin setUser={setUser} />}
          </Content>
        </>
      ) : (
        <>
          <Header>
            <Title>Cartola Resenha</Title>

            {user.adm ? (
              <Menu>
                <MenuButton
                  className={currentPage === "dados" ? "active" : ""}
                  onClick={() => setCurrentPage("dados")}
                >
                  Rodada
                </MenuButton>
                <MenuButton
                  className={currentPage === "rodadas" ? "active" : ""}
                  onClick={() => setCurrentPage("rodadas")}
                >
                  Rodadas
                </MenuButton>
                <MenuButton
                  className={currentPage === "times" ? "active" : ""}
                  onClick={() => setCurrentPage("times")}
                >
                  Times
                </MenuButton>
                <MenuButton
                  className={currentPage === "usuarios" ? "active" : ""}
                  onClick={() => setCurrentPage("usuarios")}
                >
                  Usuários
                </MenuButton>
                <MenuButton
                  className={currentPage === "financas" ? "active" : ""}
                  onClick={() => setCurrentPage("financas")}
                >
                  Finanças
                </MenuButton>
                <MenuButton
                  className={currentPage === "adminPix" ? "active" : ""}
                  onClick={() => setCurrentPage("adminPix")}
                >
                  PIX
                </MenuButton>
                <MenuButton
                  className={currentPage === "adminSaldos" ? "active" : ""}
                  onClick={() => setCurrentPage("adminSaldos")}
                >
                  Saldos
                </MenuButton>
                <LogoutButton onClick={handleLogout}>Sair</LogoutButton>
              </Menu>
            ) : (
              <Menu>
                <MenuButton
                  className={currentPage === "dados" ? "active" : ""}
                  onClick={() => setCurrentPage("dados")}
                >
                  Rodada
                </MenuButton>
                <MenuButton
                  className={currentPage === "meusTimes" ? "active" : ""}
                  onClick={() => setCurrentPage("meusTimes")}
                >
                  Meus Times
                </MenuButton>
                <MenuButton
                  className={currentPage === "financeiro" ? "active" : ""}
                  onClick={MenuFinanceiro}
                >
                  Financeiro
                </MenuButton>
                <MenuButton
                  className={currentPage === "pagamentos" ? "active" : ""}
                  onClick={() => setCurrentPage("pagamentos")}
                >
                  Pagamentos
                </MenuButton>
                <LogoutButton onClick={handleLogout}>Sair</LogoutButton>
              </Menu>
            )}
          </Header>

          <Content>
            {currentPage === "usuarios" && (
              <>
                <FormUsuarios onEdit={onEdit} setOnEdit={setOnEdit} getUsers={getUsers} />
                <GridUsuarios setOnEdit={setOnEdit} users={users} setUsers={setUsers} />
              </>
            )}

            {currentPage === "times" && (
              <>
                <FormTimes onEdit={onEdit} setOnEdit={setOnEdit} getUsers={getTimes} />
                <GridTimes setOnEdit={setOnEdit} users={times} setUsers={setTimes} />
              </>
            )}

            {currentPage === "rodadas" && (
              <>
                <FormRodada
                  onEdit={onEdit}
                  setOnEdit={setOnEdit}
                  getUsers={getRodadas}
                  onLigaChange={(idLiga) => { setRodadasLiga(idLiga); getRodadas(idLiga); }}
                />
                <GridRodadas users={rodada} setOnEdit={setOnEdit} getUsers={() => getRodadas(rodadasLiga)} />
              </>
            )}

            {currentPage === "dados" && (
              <DadosRodada isAdmin={user.adm} user={user} />
            )}

            {currentPage === "meusTimes" && (
              <div style={{ textAlign: "center", padding: "30px", color: "#666" }}>
                <h3>Em desenvolvimento...</h3>
              </div>
            )}

            {currentPage === "financeiro" && (
              <DescricaoFinanceiro financeiro={financeiro} adm={false} />
            )}

            {currentPage === "financas" && (
              <FormFinancas onEdit={onEdit} setOnEdit={setOnEdit} getUsers={getUsers} />
            )}

            {currentPage === "pagamentos" && (
              <TelaPagamentos
                usuario={user}
                onSaldoAtualizado={() => {
                  const storedUser = localStorage.getItem("user");
                  if (storedUser) setUser(JSON.parse(storedUser));
                }}
              />
            )}

            {currentPage === "adminPix" && <AdminPix />}

            {currentPage === "adminSaldos" && <AdminSaldos />}
          </Content>
        </>
      )}

      <ToastContainer autoClose={3000} position="bottom-left" />
    </AppWrapper>
  );
}

export default App;

